var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14847 2.13383C7.22237 1.86776 7.0666 1.59215 6.80053 1.51825C6.53446 1.44434 6.25886 1.60011 6.18495 1.86618L5.17555 5.5H2.66671C2.39056 5.5 2.16671 5.72386 2.16671 6C2.16671 6.27615 2.39056 6.5 2.66671 6.5H4.89778L3.87926 10.1667H1.33337C1.05723 10.1667 0.833374 10.3905 0.833374 10.6667C0.833374 10.9428 1.05723 11.1667 1.33337 11.1667H3.60148L2.85161 13.8662C2.77771 14.1323 2.93348 14.4079 3.19955 14.4818C3.46562 14.5557 3.74123 14.3999 3.81513 14.1338L4.63934 11.1667H9.60148L8.85161 13.8662C8.77771 14.1323 8.93348 14.4079 9.19955 14.4818C9.46562 14.5557 9.74122 14.3999 9.81513 14.1338L10.6393 11.1667H13.3334C13.6095 11.1667 13.8334 10.9428 13.8334 10.6667C13.8334 10.3905 13.6095 10.1667 13.3334 10.1667H10.9171L11.9356 6.5H14.6667C14.9429 6.5 15.1667 6.27615 15.1667 6C15.1667 5.72386 14.9429 5.5 14.6667 5.5H12.2134L13.1485 2.13383C13.2224 1.86776 13.0666 1.59215 12.8005 1.51825C12.5345 1.44434 12.2589 1.60011 12.1849 1.86618L11.1756 5.5H6.21342L7.14847 2.13383ZM9.87926 10.1667L10.8978 6.5H5.93564L4.91712 10.1667H9.87926Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.bbfaae6f44926de643c93dcb6eacb8a6.svg";
export { ForwardRef as ReactComponent };